// IEでArray#fill動かないので
export default function fillArray<T>(ary: T[], v: T): T[] {
  for (let i = 0; i < ary.length; i = i + 1) {
    ary[i] = v;
  }
  return ary;
}



// WEBPACK FOOTER //
// ./src/utils/fillArray.ts